import type {
    SearchResultFile,
    SearchFile,
    Annotation,
    User,
} from '../../data/schema/SubstrateSearchResponse';

export default function convertSearchResultFileToFileItemType(
    searchResult: SearchResultFile,
    annotations?: Annotation[]
): SearchFile {
    // TODO for tabbed search: enable merging of different content sources. https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/125251
    // The different sources have totally different fields. 3S folks claim they don't; need to try the request to merge in the query

    // Get the author and modifier information from Annotations if available
    let author: User, createdDate: string, modifiedBy: User, lastModifiedDate: string;
    if (annotations?.length > 0) {
        let isCreated, isModified, isShared, isRead, isTrending;
        // Sort the annotations by recency, so only the most recent of each type is considered
        const sortedAnnotations = annotations.sort((a1, a2) => {
            if (a1.Timestamp && a2.Timestamp) {
                return a2.Timestamp.localeCompare(a1.Timestamp);
            }
            return 0;
        });
        sortedAnnotations.forEach(annotation => {
            if (annotation.Type == 'Modified' && !isModified) {
                isModified = true;
                modifiedBy = annotation.User;
                lastModifiedDate = annotation.Timestamp;
            } else if (annotation.Type == 'Created' && !isCreated) {
                isCreated = true;
                author = annotation.User;
                createdDate = annotation.Timestamp;
            } else if (annotation.Type == 'Shared' && !isShared) {
                isShared = true;
                // TODO: handle Shared annotation
            } else if (annotation.Type == 'Read' && !isRead) {
                isRead = true;
                // TODO: handle Read annotation
            } else if (annotation.Type == 'Trending' && !isTrending) {
                isTrending = true;
                // TODO: handle Trending annotation
            }
        });
    }

    // Determine the correct URL for the file. This logic was reached via manual experimentation
    const linkingUrl =
        searchResult.LinkingUrl ??
        searchResult.ServerRedirectedURL ??
        searchResult.OriginalPath ??
        searchResult.ClassicAttachmentVisualizationUrl ??
        '';
    // Hx logic to determine the URL. For OneDrive provenance, the Path link leads to a download instead of a webpage. Awaiting 3S partner guidance.
    /*
    const linkingUrl =
        searchResult.Path ??
        searchResult.DefaultEncodingUrl ??
        searchResult.ClassicAttachmentVisualizationUrl ??
        '';
    */

    return {
        ItemId: searchResult.UniqueId ?? searchResult.Id ?? searchResult.DocId ?? '', // TODO: get correct ID fields that work for all sources/types
        FileName: searchResult.FileName ?? searchResult.Filename,
        Title: searchResult.Title,
        FileExtension: searchResult.FileExtension,
        LinkingUrl: linkingUrl,
        // Fall back to traditional values if annotations are lacking
        Author: author?.DisplayName ? [author.DisplayName] : searchResult.Author,
        AuthorUpn: author?.Upn || '',
        Created: createdDate ?? searchResult.Created,
        ModifiedBy: modifiedBy?.DisplayName ?? searchResult.ModifiedBy,
        ModifiedByUpn: modifiedBy?.Upn || '',
        LastModifiedTime: lastModifiedDate ?? searchResult.LastModifiedTime,
    };
}
